module.exports = ".footer {\n  width: 100%;\n  height: 60px;\n  background: var(--pink);\n  -webkit-box-shadow: 0px -6px 5px -7px rgba(0, 0, 0, 0.75);\n  box-shadow: 0px -6px 5px -7px rgba(0, 0, 0, 0.75);\n  position: fixed;\n  bottom: 0; }\n\n.text-center {\n  display: block;\n  padding-top: 6px;\n  margin-left: auto;\n  margin-right: auto; }\n\na {\n  font-weight: bold;\n  color: #000;\n  text-decoration: none !important; }\n\na:hover {\n  text-decoration: underline !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/footer/footer.component.scss
// module id = ./src/app/pages/footer/footer.component.scss
// module chunks = main